export default __webpack_public_path__ + "static/media/480_dummy2016-kosmetik-mobile-de.5aaacc8c.png";